import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { Checkbox } from 'components/UI'

import { getPaymentOptions } from '../../../../../../routing/fetchingfunction/user/user.action'
import { selectPaymentOptions } from '../../../../../../routing/fetchingfunction/user/user.reducer'

const PaymentPreferences = React.forwardRef(({ onChange, value: selected }, ref) => {
  const dispatch = useDispatch()

  const paymentOptions = useSelector(selectPaymentOptions)

  const onChangeHandler = (isChecked, value) => {
    const state = isChecked ? selected.concat(value) : selected.filter((e) => e !== value)
    onChange(state)
  }

  useEffect(() => {
    if (!paymentOptions.length) {
      dispatch(getPaymentOptions())
    }
  }, [])

  return (
    <div className="grid grid-cols-2 gap-2">
      {paymentOptions.map(({ name, id }) => (
        <div key={id} className="bg-white flex items-center rounded-2 border !border-[#ffca84]">
          <Checkbox
            label={name}
            wrapperClassName="py-[10px] px-[14px] h-[46px] w-full"
            checked={!!selected.find((value) => value === id)}
            onChange={({ target }) => onChangeHandler(target.checked, id)}
          />
        </div>
      ))}
    </div>
  )
})

PaymentPreferences.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default React.memo(PaymentPreferences)
